import { PanelBody, ToggleControl, RadioControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

import WpMediaPreview from "~buildable/components/wp-media-preview";
import {MediaTypeLabels, MediaTypeOptions} from "~buildable/utils/media-enums";

const BlockBgOptions = props => {
  const {
    setAttributes
  } = props;

  const {
    enableTransparentBg,
    bgMediaType,
    bgMedia,
    bgMediaArray,
    bgMediaFixed,
    bgMediaAllowsVideo = false,
    bgMediaAllowsMultipleImages = false
  } = props.blockAttributes;

  const allowedTypes = bgMediaAllowsVideo
    ? [MediaTypeOptions.IMAGE, MediaTypeOptions.VIDEO]
    : [MediaTypeOptions.IMAGE];

  const typeOptions = allowedTypes.map(type => {
    return {
      label: type === MediaTypeOptions.IMAGE && bgMediaAllowsMultipleImages
        ? `${MediaTypeLabels[type]}(s)`
        : MediaTypeLabels[type],
      value: type
    }
  });

  const typeIsMultiImage = bgMediaType === MediaTypeOptions.IMAGE && bgMediaAllowsMultipleImages;

  const mediaIdsString = typeIsMultiImage
    ? bgMediaArray.reduce((acc, m) => `${acc}_${m.id}`, "")
    : (!!bgMedia && typeof bgMedia.id !== "undefined" ? `_${bgMedia.id}` : "");

  return !enableTransparentBg ? (
    <PanelBody
      className="background-options"
      title={ __("Background Options") }
    >
      { typeOptions.length > 1 && (
        <RadioControl
          label={ __("Media Type") }
          options={ typeOptions }
          selected={ bgMediaType }
          onChange={ bgMediaType => setAttributes({ bgMediaType }) }
        />
      )}

      <WpMediaPreview
        key={ `preview_${bgMediaType}_${typeIsMultiImage ? 'multi_image' : ''}${mediaIdsString}` }
        media={ typeIsMultiImage ? bgMediaArray : bgMedia }
        onChange={
          bgMediaOrMediaArray =>
            setAttributes({ [`${typeIsMultiImage ? 'bgMediaArray' : 'bgMedia'}`]: bgMediaOrMediaArray })
        }
        onRemove={ () =>
          setAttributes( typeIsMultiImage ? { bgMediaArray: [] } : { bgMedia: {} })
        }
        onUpdateArray={ bgMediaArray => setAttributes({ bgMediaArray }) }
        allowedTypes={ [bgMediaType] }
        allowMultiple={ bgMediaAllowsMultipleImages && bgMediaType === MediaTypeOptions.IMAGE }
        displayAsImg
      />

      <ToggleControl
        label={ __("Fixed Background") }
        checked={ bgMediaFixed }
        onChange={ bgMediaFixed => setAttributes({ bgMediaFixed }) }
      />
    </PanelBody>
  ) : null
}

export default BlockBgOptions;
